import DashboardLayout from "../../layout/DashboardLayout.tsx";
import AttributePage from "../../components/pages/AttributePage.tsx";

export default function AttributeView() {
    return (
        <>
            <DashboardLayout>
                <AttributePage/>
            </DashboardLayout>
        </>
    )
}
